const defaults = {
  inputClass: '.file__input',
  labelClass: '.file__label'
};

class File {
  constructor (element) {
    this.options = defaults;
    this.input = element.querySelector(this.options.inputClass);
    this.label = element.querySelector(this.options.labelClass);
    this.labelValue = this.label.innerText;
  }

  addEventListeners () {
    this.input.addEventListener('change', event => {
      let fileName = '';

      if (this.input.files && this.input.files.length > 1) {
        fileName = (this.input.getAttribute('data-multiple-label') || '').replace('{count}', this.input.files.length);
      } else {
        fileName = this.input.value.split('\\').pop();
      }

      if (fileName) {
        this.label.innerText = fileName;
      } else {
        this.label.innerText = this.labelValue;
      }
    });
  }

  init () {
    this.addEventListeners();
  }
}

export default File;
